import {
    get,
    post,
    postWithQuery,
    put,
    Delete,
    formDataPost,
    axios
} from "../ApiDecorator"; // 倒入 api
import qs from "qs";

const Paired = {
    // 获取全部结对空间
    getListByProject(data) {
        return get("/course/spx/listByProject", data);
    },
    // 项目主页关键指标：结对校/班级/课程/作业/观思问
    getProjectStats(data) {
        return get("/course/spx-project/stats", data);
    },
    // 项目主页精彩课堂：子空间推荐通过 ∪ 校级课关联子空间
    getSharedCourses(data) {
        return get("/course/spx-project/shared-courses", data);
    },
    // 项目主页结对空间统计：按省覆盖学校数、参与人数
    getProjectProvinceStats(data) {
        return get("/course/spx-project/stats/province", data);
    },
    // 项目主页结对空间统计：京地结对关系 Tab
    getProjectSpaceRegionStats(data) {
        return get("/course/spx-project/stats/space-region", data);
    },
    // 项目主页结对空间统计：校级空间分页列表
    // provinceIds 用重复 key：provinceIds=11&provinceIds=15
    getProjectSchoolSpaces(data) {
        const params = { ...data, noCache: new Date().getTime() }
        if (Array.isArray(params.provinceIds)) {
            params.provinceIds = params.provinceIds.filter(
                id => id !== undefined && id !== null && id !== ''
            )
            if (!params.provinceIds.length) delete params.provinceIds
        } else if (params.provinceIds === '' || params.provinceIds == null) {
            delete params.provinceIds
        }
        const query = qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
        return axios.get(`/course/spx-project/school-spaces?${query}`).then(res => res.data)
    },
    // 项目主页空间课表：全部校级空间（非分页）
    getProjectSchoolSpacesAll(data) {
        return get("/course/spx-project/school-spaces/all", data);
    },
    // 项目主页结对班级统计：班级空间分页列表
    // parentIds 用重复 key：parentIds=1&parentIds=2；spxName 模糊搜索
    getProjectClassSpaces(data) {
        const params = { ...data, noCache: new Date().getTime() }
        if (Array.isArray(params.parentIds)) {
            params.parentIds = params.parentIds.filter(
                id => id !== undefined && id !== null && id !== ''
            )
            if (!params.parentIds.length) delete params.parentIds
        } else if (params.parentIds === '' || params.parentIds == null) {
            delete params.parentIds
        }
        if (params.spxName === '' || params.spxName == null) {
            delete params.spxName
        }
        const query = qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
        return axios.get(`/course/spx-project/class-spaces?${query}`).then(res => res.data)
    },
    // 获取我的结对空间
    getListByOwner(data) {
        return get("/course/spx/listByOwner", data);
    },
    // —— 空间课表（与校级空间首页课程表同源）——
    // 月课表：线上/空间课程，按日分组
    getMyCourseSchedule(data) {
        return get("/course/spx/course/myCourseSchedule", data);
    },
    // 指定自然周：线下课，按日分组
    getCoursesByTime(data) {
        return get("/learn/spx/schedule/coursesByTime", data);
    },
    // 已发布排课明细
    getPublishedCourseSchedule(data) {
        return get("/learn/study/courseSchedule/publishedDetail", data);
    },
    // 项目周期（限制可切周范围）
    getProjectDetailTime(data) {
        return get("/learn/project/selectDetail", data);
    },
    // 已发布课次详情（补全课程名/地点等）
    getCourseScheduleItemDetail(data) {
        return get("/learn/study/courseSchedule/items/detail", data);
    },
    // 空间管理-课表列表（spaceIds 数组：spaceIds=1&spaceIds=2）
    getCourseList(data) {
        return get("/learn/spx/schedule/scheduleRowsBySpaceIds", data);
    },
    // 导出课表 Excel（与校级课程表一致）
    getExportScheduleExcel(data) {
        const params = { ...data, noCache: new Date().getTime() }
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&')
        return axios.get(`/learn/spx/schedule/exportScheduleExcel?${query}`, {
            responseType: 'blob',
        }).then(res => res.data)
    },
    // 导出课表 Word 压缩包（与校级课程表一致）
    getExportScheduleWordZip(data) {
        const params = { ...data, noCache: new Date().getTime() }
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&')
        return axios.get(`/learn/spx/schedule/exportScheduleWordZip?${query}`, {
            responseType: 'blob',
        }).then(res => res.data)
    },
    // 兼容旧调用名
    exportCourseList(data) {
        return Paired.getExportScheduleWordZip(data)
    },

    // —— 子空间公共 ——
    // 分页查询项目下校级空间（createType 固定为 1）
    getSchoolPage(data) {
        return get("/course/spx/school/page", data);
    },
    // 分页查询子空间（结对班级 / 研伴）
    getChildrenPage(data) {
        return get("/course/spx/children/page", data);
    },
    // Excel 批量导入结对班级空间 / 研伴空间
    batchImport(data) {
        return formDataPost("/course/spx/batchImport", data);
    },

    // —— 结对班级空间 ——
    createSpxClass(data) {
        return post("/course/spx-class/createSpxClass", data);
    },
    updateSpxClass(data) {
        return post("/course/spx-class/updateSpxClass", data);
    },
    deleteSpxClass(data) {
        return Delete("/course/spx-class/deleteSpxClass", data);
    },
    getClassesBySchools(data) {
        return get("/course/spx-class/classesBySchools", data);
    },
    pageSpxClassByParent(data) {
        return get("/course/spx-class/pageByParent", data);
    },

    // —— 研伴空间 ——
    createSpxPartner(data) {
        return post("/course/spx-partner/create", data);
    },
    updateSpxPartner(data) {
        return post("/course/spx-partner/updateSpxPartner", data);
    },
    deleteSpxPartner(data) {
        return Delete("/course/spx-partner/deleteSpxPartner", data);
    },
    getPartnerUserOptions(data) {
        return get("/course/spx-partner/userOptions", data);
    },
    getPartnerList(data) {
        return get("/course/spx-partner/list", data);
    },
    // 成员活跃度分页。一行是一个师傅或徒弟在一个研伴子空间中的统计
    getPartnerActivity(data) {
        return get("/course/spx-partner/activity", data);
    },
    // 当前登录人是否为研伴负责人
    isPartnerLeader(data) {
        return get("/course/spx-partner/isLeader", data);
    },
    // 当前登录用户担任学科负责人的研伴空间（id + 名称）
    getPartnerLeaderSpaces(data) {
        return get("/course/spx-partner/leaderSpaces", data);
    },
    // 学科负责人名下研伴空间总结分页列表
    getPartnerSummaryLeaderList(data) {
        return get("/course/spx-partner/summary/leaderList", data);
    },
    // 研伴空间总结详情（含正文与附件）
    getPartnerSummaryDetail(data) {
        return get("/course/spx-partner/summary/detail", data);
    },
    // 学科负责人评价研伴空间总结（覆盖更新；空白则清空）
    evaluatePartnerSummary(data) {
        return post("/course/spx-partner/summary/evaluate", data);
    },

    // —— 空间精彩瞬间（一空间一条，与项目级 /course/moment 无关）——
    createSpaceMoment(data) {
        return post("/course/spx/spaceMoment/create", data);
    },
    updateSpaceMoment(data) {
        return post("/course/spx/spaceMoment/update", data);
    },
    getSpaceMoment(data) {
        return get("/course/spx/spaceMoment/getMoment", data);
    },
    // —— 空间试卷 ——
    // 专家确认页：当前项目的子空间，供空间筛选
    getExamPaperChildSpaces(data) {
        return get("/course/spx/examPaper/childSpaces", data);
    },
    // 专家试卷列表：projectId 必填，spxId、keyword 可选
    getExamPaperListForExpert(data) {
        return get("/course/spx/examPaper/listForExpert", data);
    },
    // 试卷题目列表（含批注）
    getExamPaperQuestionList(data) {
        return get("/course/spx/examPaper/question/list", data);
    },
    // 细目表维度标记回显
    getExamComposeQuestionMark(data) {
        return get("/course/spx/examCompose/questionMark", data);
    },
    // 新增题目批注
    createExamPaperQuestionNote(data) {
        return post("/course/spx/examPaper/question/note", data);
    },
    // 修改题目批注（仅本人）
    updateExamPaperQuestionNote(data) {
        return put("/course/spx/examPaper/question/note", data).then(res => {
            // put 封装返回的是 axios response，这里统一成 { code, msg, data }
            return res && res.data !== undefined && res.code === undefined ? res.data : res
        })
    },
    // 删除题目批注（仅本人，逻辑删除）
    deleteExamPaperQuestionNote(data) {
        return Delete("/course/spx/examPaper/question/note", data);
    },
    // 整卷点评列表：paperId 必填；question_id 为空的记录
    getExamPaperReviewList(data) {
        return get("/course/spx/examPaper/review/list", data);
    },
    // 新增整卷点评（累加；改/删仍用题目批注的 put/delete，传点评 id）
    createExamPaperReview(data) {
        return post("/course/spx/examPaper/review", data);
    },
    // 终版可行性确认：query 传 relId、status；不可行原因放 JSON body
    submitExamPaperFeasibility(query, body) {
        return postWithQuery("/course/spx/examPaper/feasibility", body || {}, query);
    },
    // 专家过程溯源：projectId 必填；paperId / relId 至少一个
    getExamPaperLineageForExpert(data) {
        return get("/course/spx/examPaper/lineageForExpert", data);
    },
    // 专家关键能力目录：projectId、versionType 必填；keyword 可选
    getExamPaperAbilityCatalogForExpert(data) {
        return get("/course/spx/examPaper/abilityCatalogForExpert", data);
    },
    // 专家关键能力题目：projectId、taskId、abilityName、versionType 必填
    getExamPaperAbilityQuestionsForExpert(data) {
        return get("/course/spx/examPaper/abilityQuestionsForExpert", data);
    },
}

export default Paired
